var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3672 13.6914C26.3672 21.1797 21.252 26.4531 13.7109 26.4531C6.4336 26.4531 0.632814 20.6524 0.632814 13.375C0.632814 6.1504 6.4336 0.296889 13.7109 0.296889C17.1914 0.296889 20.1973 1.61525 22.4648 3.72462L18.8789 7.15236C14.2383 2.66994 5.58985 6.04494 5.58985 13.375C5.58985 17.9629 9.22852 21.6543 13.7109 21.6543C18.8789 21.6543 20.8301 17.9629 21.0938 16.0117H13.7109V11.5293H26.1563C26.2617 12.2149 26.3672 12.8477 26.3672 13.6914Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSvg);
export default __webpack_public_path__ + "static/media/googleSvg.1125c13b1feb56d063a3e27ed470c5c0.svg";
export { ForwardRef as ReactComponent };